<template>
  <div class="details">
    <breadcrumb></breadcrumb>
    <div class="flex-center">
      <div class="content">
          <!-- <div class="title">{{data.title||''}}</div>
          <div class="time" v-if="data.createTime">发布时间：{{data.createTime}}</div> -->
          <div v-html="data.rich_text1768183891132||'暂无内容'"></div>
      </div>
    </div>
  </div>
</template>

<script>

import {queryForm} from '@/api/api.js'
import breadcrumb from '@/components/breadcrumb.vue'
export default {
  components:{
    breadcrumb
  },
  data(){
      return {
        id:'',
        data:{},
      }
  },
  
  created(){
    this.id=this.$route.query.id
    this.getData()
  },
  methods:{
    getData(){
      queryForm({
        formKey: "cj3MrDyo",
        queryId: "281",
        queryParams: {
          id: this.id
        },
        size: 1,
        current: 0
      }).then(res=>{
        if(res.data.code==200){
          this.data=res.data.data.rows[0]||{}
        }
      })
    },
    
  }
}
</script>

<style lang="less" scoped>
.details{
  padding:0 10%;
  padding-bottom: 109px;
  padding-top: 26px;
  .content{
    width: 56.25%;
    background: #fff6e8;
    padding:64px;
    margin-top:48px;
    height: 1383px;
    font-size: 20px;
    color: #333333;
    .title{
      font-size: 36px;
      color: #ed9d26;
      font-weight: bold;
      text-align: center;
    }
    .time{
      font-size: 20px;
      color: #333333;
      margin:32px 0;
      text-align:center;
    }
    ::v-deep {
      img {
        max-width: 100% !important;
        height: auto !important;
        display: block;
        margin: 10px auto;
      }
      table {
        max-width: 100% !important;
        border-collapse: collapse;
        margin: 10px 0;
        overflow-x: auto;
        display: block;
      }
      table td, table th {
        border: 1px solid #ddd;
        padding: 8px;
        word-wrap: break-word;
        word-break: break-all;
      }
      p, div, span {
        max-width: 100%;
        word-wrap: break-word;
        word-break: break-word;
      }
      video, iframe {
        max-width: 100% !important;
        height: auto !important;
      }
      pre {
        max-width: 100%;
        overflow-x: auto;
        word-wrap: break-word;
        word-break: break-all;
      }
      * {
        box-sizing: border-box;
      }
    }
  }
}

::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover{
  color: #303133;
  font-weight: 700;
}
::v-deep .el-breadcrumb__inner a,::v-deep .el-breadcrumb__inner.is-link{
  color: #606266;
  font-weight: 400;
}
</style>
